







































import { computed, defineComponent } from '@nuxtjs/composition-api';

import Tooltip from '~/components/common/Tooltip.vue';
import RatingBars from '~/components/Product/components/RatingBars/RatingBars.vue';
import ReviewsBar from '~/components/ReviewsBar.vue';
import { useProductPageState } from '~/composables';
import { PRODUCT_TABS } from '~/composables/useProductTabs';
import isServer from '~/helpers/isServer';
import { smoothScrollToElement } from '~/helpers/smoothScrollToElement';

export default defineComponent({
  name: 'ProductReviews',

  components: {
    Tooltip,
    ReviewsBar,
    RatingBars,
  },

  props: {
    rating: {
      type: [String, Number],
      required: true,
      default: 0,
    },
    count: {
      type: [String, Number],
      required: true,
      default: 0,
    },
    reviewsStars: {
      type: Array,
      default: () => ([]),
    },
  },
  setup(props) {
    const { setActiveTab } = useProductPageState();

    const ratings = computed(() => ({
      stars: props.reviewsStars,
      total: props.count,
    }));

    const showReviews = () => {
      setActiveTab(PRODUCT_TABS.reviews);
      smoothScrollToElement(`#${PRODUCT_TABS.reviews}`);
    };

    return {
      clientSide: computed(() => !isServer),
      ratings,
      showReviews,
    };
  },
});
